import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-p-10 tw-flex tw-flex-col tw-gap-[40px]" }
const _hoisted_2 = { class: "tw-flex tw-flex-col tw-gap-[10px]" }
const _hoisted_3 = { class: "tw-font-semibold tw-text-[#211F58] tw-text-[25px]" }
const _hoisted_4 = { class: "tw-text-[13px] tw-text-[#878787] xl:tw-w-[882px]" }
const _hoisted_5 = { class: "tw-flex tw-flex-col tw-gap-[20px]" }
const _hoisted_6 = { class: "tw-text-[16px] tw-font-semibold tw-leading-[130%] tw-text-[#211F58]" }
const _hoisted_7 = { class: "tw-ml-[20px] tw-px-[5px] tw-w-fit tw-py-[3px] tw-h-[20px] tw-bg-[#E4F1FF] tw-rounded-[4px] tw-text-[#387DFF] tw-text-[11px] tw-font-medium tw-leading-[130%] tw-font-[Poppins]" }
const _hoisted_8 = { class: "tw-flex-1 tw-flex tw-justify-end tw-mr-[10px] tw-ml-[10px] tw-min-w-[75px]" }
const _hoisted_9 = ["disabled", "onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "11.1",
    stroke: "#F7553C",
    "stroke-width": "1.8"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "7",
    y: "11",
    width: "10",
    height: "2.4",
    rx: "0.6",
    fill: "#F7553C"
  })
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "tw-w-[44px]"
}
const _hoisted_13 = { class: "tw-flex tw-justify-between tw-mt-[25px]" }
const _hoisted_14 = { class: "tw-flex tw-flex-row tw-gap-[15px]" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "tw-p-[25px]" }
const _hoisted_17 = { class: "tw-text-[14px] tw-font-[500] tw-text-[#211F58]" }
const _hoisted_18 = { class: "tw-py-[10px] tw-text-[13px] tw-font-[400] tw-text-[#231F20] tw-text" }

import ProgressAnimation from "../../assets/animation/progress_light.json";
import { LottieAnimation } from "lottie-web-vue";
import ModalHeader from "@/components/common/modalHeader.vue";
import { getComponentUiText, validDateAction } from "@/utils/utilities";
import { ref, watch } from "vue";
import ModalComponent from "@/components/common/modalComponent.vue";
import WizardInputQuestion from "../wizard/wizardInputQuestion.vue";
import { INPUT_TYPE } from "@/utils/constants";
import { PropType } from "vue";
import { computed } from "vue";
import {
  deleteChecklistForecasts,
  createChecklistForecasts,
} from "@/services/recommend";
import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { Checklist } from "@/services/apiRoutes/routes";
import store from "@/store";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";
import ButtonShowDuplicateAssessment from "@/components/common/setting/buttonShowDuplicateAssessment.vue";
import { CHECKLISTSTATUS } from "@/utils/constants";
import AssessmentChecklistStatusTag from "@/components/assessment/assessmentChecklistStatusTag.vue";
import eventEmitter, { EmitterEvents } from "@/utils/eventEmitter";

export default /*#__PURE__*/_defineComponent({
  __name: 'securityAndStabilityScoreModal',
  props: {
  show: {
    type: Boolean,
    required: true,
  },
  data: {
    type: Object as PropType<any[]>,
    required: true,
  },
  idSelected: {
    type: Number,
    required: false,
    default: 0,
  },
},
  emits: ["update:show"],
  setup(__props, { emit }) {

const props = __props;



const isSubmitting = ref(false);
const showRef = ref(props.show);
const dataForecast = ref(
  props.data.map((item) => {
    return {
      ...item,
      forecastDate: item.completionDate
        ? convertUTCTimeToLocalTime(item.completionDate)
        : "",
    };
  }),
);
const checklistForecasts = computed(() => {
  return store.state.Recommend.dataChecklistForecasts;
});

const checklistGroups = computed(() => {
  return store.state.Recommend.checklistGroups;
});

const checklistId = computed(
  () => store.getters["Recommend/getLatestChecklistId"],
);

const currentChecklistReportId = computed(
  () => store.getters["Recommend/getChecklistReportId"],
);

watch(
  () => props.data,
  (newVal) => {
    dataForecast.value = newVal.map((item) => {
      return {
        ...item,
        forecastDate: item.completionDate
          ? convertUTCTimeToLocalTime(item.completionDate)
          : "",
      };
    });
  },
);



const onScroll = () => {
  eventEmitter.emit(EmitterEvents.SCROLL_MODAL);
};

const handleCloseModal = (isCloseWiard = false) => {
  showRef.value = false;
  emit("update:show", showRef.value);
};

const handleClearAll = () => {
  dataForecast.value = dataForecast.value.map((item) => {
    return {
      ...item,
      forecastDate: "",
    };
  });
};

const handleClearItem = (index) => {
  dataForecast.value[index].forecastDate = "";
};

const handleSave = async () => {
  isSubmitting.value = true;
  try {
    if (checklistForecasts.value.length) {
      const dataDelete = {
        checklistId: currentChecklistReportId.value,
        forecastIds: checklistForecasts.value.map((item) => item.forecastId),
      };
      await deleteChecklistForecasts(dataDelete);
    }
    const listForecastSort = dataForecast.value
      .filter((item) => item.forecastDate)
      .sort((a, b) => {
        return (
          new Date(b.forecastDate).getTime() -
          new Date(a.forecastDate).getTime()
        );
      });

    const data: any[] = [];

    listForecastSort.forEach((item) => {
      data.forEach((itemData) => {
        itemData.checklistGroupIds.push(item.id);
      });
      if (
        !data.length ||
        !(
          new Date(data[data.length - 1].forecastDate).getTime() ===
          new Date(item.forecastDate).getTime()
        )
      ) {
        data.push({
          checklistId: currentChecklistReportId.value,
          forecastDate: new Date(item.forecastDate),
          forecastCompliance: 0.9,
          checklistGroupIds: [item.id],
        });
      }
    });

    await Promise.all(data.map((item) => createChecklistForecasts(item)));
    await store.dispatch("Recommend/fetchChecklistForecasts");
    showSuccessToast(
      getComponentUiText(
        "app-recommend-security-and-stability-score-message-save-forecast-success-1",
      ),
    );
    handleCloseModal();
  } catch (error) {
    showErrorAPI(error, Checklist.deleteChecklistForecasts);
  } finally {
    // isSubmitting.value = false;
  }
};

const classModal = {
  background: "rgba(35, 31, 32, 0.5)",
};

const styleClassContain = computed(() => {
  return {
    "border-radius": "4px",
    "box-shadow": "0px 0px 4px 0px rgba(0, 0, 0, 0.05)",
    overflow: "auto",
  };
});

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(ModalComponent, {
    "modal-class": `${showRef.value ? 'date-picker-modal' : ''}`,
    "model-value": showRef.value,
    close: handleCloseModal,
    "max-width": 65,
    "style-class": classModal,
    "style-class-contain": styleClassContain.value,
    onScrollModal: onScroll
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        "is-header": '',
        style: {"z-index":"10"},
        title: 
        _unref(getComponentUiText)('app-recommend-security-and-stability-score-title-1')
      ,
        onClose: handleCloseModal
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(getComponentUiText)(
              "app-recommend-security-and-stability-score-title-forecast-1",
            )), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(getComponentUiText)(
              "app-recommend-security-and-stability-score-description-1",
            )), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(getComponentUiText)(
              "app-recommend-security-and-stability-score-title-estimated-1",
            )), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataForecast.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id
            }, [
              _createVNode(WizardInputQuestion, {
                "is-security-and-stability-score": true,
                "model-value": item.forecastDate,
                type: _unref(INPUT_TYPE).Date,
                title: item.checklistGroupName || '',
                required: false,
                disabled: isSubmitting.value,
                "valid-message": 
              _unref(getComponentUiText)('app-api-error-invalid-forecast-date-1')
            ,
                "valid-state": 
              _unref(validDateAction)(item.id, checklistGroups.value, dataForecast.value)
            ,
                "validation-class": '!tw-ml-[15px]',
                placeholder: 
              _unref(getComponentUiText)(
                'app-recommend-security-and-stability-score-placeholder-select-1',
              )
            ,
                "class-title": 'tw-text-[14px] !tw-leading-[100%]',
                "col-class": 'tw-flex tw-flex-row tw-justify-end',
                "input-class": 'md:tw-w-[420px]',
                "is-auto-focus": !item.completionDate && item.id === __props.idSelected,
                "onUpdate:modelValue": (value) => (item.forecastDate = value)
              }, _createSlots({
                rightInput: _withCtx(() => [
                  _createElementVNode("div", null, [
                    (item.forecastDate)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: _normalizeClass({
                    'tw-px-[10px] tw-h-[56px] tw-items-center tw-flex tw-cursor-pointer': true,
                    '!tw-cursor-not-allowed tw-opacity-60': isSubmitting.value,
                  }),
                          disabled: isSubmitting.value,
                          onClick: () => handleClearItem(index)
                        }, _hoisted_11, 10, _hoisted_9))
                      : (_openBlock(), _createElementBlock("div", _hoisted_12))
                  ])
                ]),
                _: 2
              }, [
                (!item.completionDate && item.id === __props.idSelected)
                  ? {
                      name: "rightHeader",
                      fn: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(getComponentUiText)(
                    "app-recommend-security-and-stability-score-select-tag-1",
                  )), 1)
                      ]),
                      key: "0"
                    }
                  : undefined,
                (item.checklistGroupCompletionPcnt !== null)
                  ? {
                      name: "statusHeader",
                      fn: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(AssessmentChecklistStatusTag, {
                            "checklist-status": 
                    item.checklistGroupCompletionPcnt === 1
                      ? _unref(getComponentUiText)(
                          'app-component-assessments-checklists-assessment-details-card-status-3',
                        )
                      : item.checklistGroupCompletionPcnt > 0 &&
                          item.checklistGroupCompletionPcnt < 1
                        ? _unref(getComponentUiText)(
                            'app-component-assessments-checklists-assessment-details-card-status-1',
                          )
                        : _unref(getComponentUiText)(
                            'app-component-assessments-checklists-assessment-details-card-status-2',
                          )
                  ,
                            "checklist-status-id": 
                    item.checklistGroupCompletionPcnt === 1
                      ? _unref(CHECKLISTSTATUS).DONE
                      : item.checklistGroupCompletionPcnt > 0 &&
                          item.checklistGroupCompletionPcnt < 1
                        ? _unref(CHECKLISTSTATUS).INPROG
                        : _unref(CHECKLISTSTATUS).NEW
                  ,
                            "class-name": '!tw-py-0 ',
                            "is-loading": false
                          }, null, 8, ["checklist-status", "checklist-status-id"])
                        ])
                      ]),
                      key: "1"
                    }
                  : undefined
              ]), 1032, ["model-value", "type", "title", "disabled", "valid-message", "valid-state", "placeholder", "is-auto-focus", "onUpdate:modelValue"])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_b_button, {
            style: {"line-height":"100%","height":"39px"},
            variant: "danger",
            disabled: isSubmitting.value,
            class: _normalizeClass({
            'tw-w-[99px] tw-mr-[15px] tw-shadow-none tw-bg-[#F7553C] tw-text-[white] tw-text-[15px] tw-font-medium tw-rounded-[27px]': true,
            '!tw-cursor-not-allowed': isSubmitting.value,
          }),
            onClick: handleClearAll
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
              "app-recommend-security-and-stability-score-clear-all-button-title-1",
            )), 1)
            ]),
            _: 1
          }, 8, ["disabled", "class"]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_b_button, {
              style: {"line-height":"100%","border":"2px solid","height":"39px"},
              variant: "normal",
              class: _normalizeClass({
              'tw-w-[90px] tw-shadow-none !tw-bg-[#fff] !tw-text-[#387DFF] tw-text-[15px] tw-font-medium tw-rounded-[27px]': true,
              '!tw-cursor-not-allowed': isSubmitting.value,
            }),
              disabled: isSubmitting.value,
              onClick: handleCloseModal
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                "app-menu-submenu-home-setup-wizard-modal-button-cancel-1",
              )), 1)
              ]),
              _: 1
            }, 8, ["class", "disabled"]),
            _createVNode(_component_b_button, {
              style: {"line-height":"100%","height":"39px"},
              variant: "primary",
              class: _normalizeClass({
              'tw-relative tw-shadow-none tw-bg-[#387DFF] tw-text-[15px] tw-font-medium tw-rounded-[27px]': true,
              '!tw-cursor-not-allowed': isSubmitting.value,
            }),
              type: "submit",
              disabled: isSubmitting.value,
              onClick: handleSave
            }, {
              default: _withCtx(() => [
                (isSubmitting.value)
                  ? (_openBlock(), _createBlock(_unref(LottieAnimation), {
                      key: 0,
                      class: _normalizeClass('tw-h-[39px] tw-w-[37px]'),
                      "animation-data": _unref(ProgressAnimation),
                      "auto-play": true,
                      loop: true
                    }, null, 8, ["animation-data"]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, _toDisplayString(_unref(getComponentUiText)(
                  "app-component-assessment-modal-assessment-save-button-1",
                )), 1)
              ]),
              _: 1
            }, 8, ["class", "disabled"]),
            (isSubmitting.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(ButtonShowDuplicateAssessment, {
                    "id-popover": 'popover-security-and-stability-score-modal',
                    "custom-class": "sm:tw-max-w-[470px] tw-max-w-[300px]",
                    classes: `tw-leading-[36px] !tw-pr-[10px]`
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(getComponentUiText)(
                      "app-recommend-security-and-stability-score-icon-info-title-1",
                    )), 1),
                        _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(getComponentUiText)(
                      "app-recommend-security-and-stability-score-icon-info-description-1",
                    )), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modal-class", "model-value", "style-class-contain"]))
}
}

})